<template>
  <b-modal
    :visible="visible"
    size="xl"
    centered
    hide-header
    body-class="p-0"
    hide-footer
    lazy
    @hidden="$emit('hide-modal')"
  >
    <b-card
      class="expertise-items border-0"
      :class="isIdxOdd ? 'expertise-items-bg-white' : 'expertise-items-bg-white-1'"
      :body-class="`${modalItem.bg}`"
    >
      <b-card-body
        class="p-0 d-flex"
      >
        <component
          :is="modalItem.component"
          :modal-item="modalItem"
        />
      </b-card-body>
    </b-card>
  </b-modal>
</template>

<script>
import Paragraph from '@/components/Paragraph';
import ClinicalTrialPhases from '@/components/Expertise/Items/ClinicalTrialPhases';
import IssIseServices from '@/components/Expertise/Items/IssIseServices';
import TherapeuticExperience from '@/components/Expertise/Items/TherapeuticExperience';
import CdiscCompliantMapping from '@/components/Expertise/Items/CdiscCompliantMapping';
import FunctionServiceProviders from '@/components/Expertise/Items/FunctionServiceProviders';

export default {
  name: 'ExpertiseItemModal',
  components: {
    Paragraph,
    ClinicalTrialPhases,
    IssIseServices,
    TherapeuticExperience,
    CdiscCompliantMapping,
    FunctionServiceProviders,
  },
  props: {
    visible: {
      type: Boolean,
      detail: false,
    },
    modalItem: {
      type: Object,
      default: null,
    },
  },
  computed: {
    isIdxOdd() {
      return !!(this.modalItem?.index % 2);
    },
  },
};
</script>
